import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv1210GetResultModel, Inv1210GetResultSchema } from './get.schema'

export async function fetchInv1210(id: number): Promise<Inv1210GetResultModel> {
  const response = await axios.get<Inv1210GetResultModel>(
    `/api/warehouse/inv1210/${id}`
  )
  console.log('fetchInv1210', response.data)
  return Inv1210GetResultSchema.parse(response.data)
}

export const getInv1210ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv1210', id],
    queryFn: () => fetchInv1210(id),
  })
